<template>
  <div class="wrapper">
    <Table :columns="tableColumns" :data="tableData.data" @on-selection-change="selectChange" border
      style="margin: 10px 0">
      <template slot-scope="{ row }" slot="index">
        {{ (tableData.current_page - 1) * 10 + row._index + 1 }}
      </template>
      <!-- <template slot-scope="{ row }" slot="is_buy">
        {{row.is_buy==1?'是':'否'}}
      </template>
      <template slot-scope="{ row }" slot="is_free">
        {{row.is_free==1?'是':'否'}}
      </template>
      <template slot-scope="{ row }" slot="is_display">
        {{row.is_display==2?'是':'否'}}
      </template> -->
      <template slot-scope="{ row }" slot="action">
        <!-- <Button v-if=" row.is_buy == 1" type="info" size="small" @click="$refs.courseDetail.getDetail(row)">查看</Button> -->
        <span v-if="row.is_buy == 1">已添加</span>
        <Button v-else type="primary" size="small" @click="addCourse(row)">添加</Button>
        <!-- <Poptip
          v-auth="'admin/delete'"
          transfer
          confirm
          title="您确定要删除这条数据吗？"
          @on-ok="removes(row)"
          style="margin-left: 5px"
        >
          <Button type="error" size="small">删除</Button>
        </Poptip> -->
      </template>
    </Table>
    <Page style="text-align: right;" :total="tableData.total" :page-size="tableData.per_page"
      :current="tableData.current_page" show-total @on-change="getData" />
    <courseDetail ref="courseDetail" />
  </div>
</template>
<script>
  import indexPage from "../../mixins/indexPage"
  import courseDetail from "./courseDetail"
  export default {
    mixins: [indexPage],
    mounted() {
      // 初始化筛选列表
      this.$store.dispatch("global/getAllSelect")
    },
    props: {
      reSearch: {
        type: Object,
        default: () => { },
      },
    },
    data() {
      return {
        // 已选择数据
        selectData: [],
        //  标题
        tableColumns: [
          {
            title: "序号",
            slot: "index",
            width: 80,
            align: "center",
          },
          {
            title: "名称",
            minWidth: 250,
            key: "name",
            align: "center",
            tooltip: true,
            tooltipMaxWidth: 120,
          },
          {
            title: "级别",
            key: "grade_name",
            align: "center",
            tooltip: true,
            minWidth: 140,
          },
          {
            title: "科目",
            key: "subject_name",
            align: "center",
            tooltip: true,
            minWidth: 140,
          },
        //   {
        //     title: "课程",
        //     key: "course_name",
        //     align: "center",
        //     tooltip: true,
        //     minWidth: 140,
        //   },
          {
            title: "录课数量",
            key: "count",
            align: "center",
            tooltip: true,
            minWidth: 140,
          },
          {
            title: "教师",
            key: "teacher_name",
            align: "center",
            minWidth: 140,
            tooltip: true,
          },
          {
            title: "头衔",
            key: "teacher_title",
            align: "center",
            minWidth: 140,
            tooltip: true,
          },
          // {
          //   title: '是否启用',
          //   slot: 'is_display',
          //   align: 'center',
          // },
          // {
          //   title: '是否购买',
          //   slot: 'is_buy',
          //   align: 'center',
          // },
          // {
          //   title: '是否免费',
          //   slot: 'is_free',
          //   align: 'center'
          // },
          {
            title: "原价",
            minWidth: 60,
            key: "original_price",
            align: "center",
            minWidth: 140,
          },
          {
            title: "现价",
            minWidth: 60,
            key: "current_price",
            align: "center",
            minWidth: 140,
          },
          {
            title: "课程页面",
            key: "course_img",
            align: "center",
            minWidth: 140,
            render: (h, params) => {
              return h("img", {
                attrs: {
                  src: `${process.env.VUE_APP_SERVER_DOMAIN}${params.row.course_img}`,
                },
                style: {
                  width: "40px",
                },
              })
            },
          },
          { title: "备注", key: "remark", align: "center", minWidth: 150, },
          { title: "操作", slot: "action", align: "center", minWidth: 180, },

        ],
        indexUrl: "/app/source_record_class_storage/index",
      }
    },
    components: {
      courseDetail,
    },
    methods: {
      search() {
        this.searchData = this.reSearch
      },
      // 购买完调用
      addSure(row) {
        let data = { record_storage_id: row.id }
        this.$axios.post("/app/my_record_storage/index", data).then((res) => {
          if (res.code == 1) {
            this.getData(this.tableData.current_page)
            this.$Message.success('添加成功')
          } else {
            this.$Message.info(res.msg)
          }
        })
      },
      // 添加课程
      addCourse(row) {
        if (row.is_buy == 0) {
          this.$Modal.confirm({
            content: "此课件需要购买，是否购买？",
            onOk: () => {
              this.$axios
                .post("/app/source_record_class_storage/buy", { id: row.id })
                .then((res) => {
                  if (res.code == 1) {
                    this.addSure(row)
                  } else {
                    this.$Message.info(res.msg)
                  }
                })
            },
          })
        } else {
          this.addSure(row)
        }
      },
      // 选择框变化
      selectChange(select) {
        this.selectData = select
      },
      // 删除课程
      removes(id) {
        this.$axios
          .delete("/app/my_record_storage/index", { id: id })
          .then((res) => {
            if (res.code == 1) {
              this.$Message.success(res.msg)
            } else {
              this.$Message.info(res.msg)
            }
          })
      },
    },
  }
</script>
<style scoped lang='less'></style>
